export const MOCK_MENU_USER = {
  "modules": [
    {
      "id": 1,
      "status": false,
      "priotary": 1,
      "description": "Usuarios",
      "subModule": [
        {
          "id": 1,
          "status": false,
          "priotary": 1,
          "route": "/users/enrollment",
          "description": "Enrolamiento de usuarios",
          "moduleId": 1,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 1,
              "status": false,
              "priotary": 1,
              "subModuleId": 1,
              "description": "Portal administración",
              "route": "/users/enrollment/admin",
              "actions": []
            },
            {
              "id": 2,
              "status": false,
              "priotary": 2,
              "subModuleId": 1,
              "description": "Portal alumnos",
              "route": "/users/enrollment/student",
              "actions": []
            }
          ]
        },
        {
          "id": 2,
          "status": false,
          "priotary": 2,
          "route": "/users/tutors",
          "description": "Tutores",
          "moduleId": 1,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 3,
              "status": false,
              "priotary": 1,
              "subModuleId": 2,
              "description": "Administración de tutores",
              "route": "/users/tutors/admin",
              "actions": []
            }
          ]
        }
      ]
    },
    {
      "id": 2,
      "status": false,
      "priotary": 2,
      "description": "Catálogos",
      "subModule": [
        {
          "id": 3,
          "status": false,
          "priotary": 1,
          "route": "/catalogs/admin",
          "description": "Administración de catálogos",
          "moduleId": 2,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 4,
              "status": false,
              "priotary": 1,
              "subModuleId": 3,
              "description": "Campus",
              "route": "/catalogs/admin/campus",
              "actions": []
            },
            {
              "id": 5,
              "status": false,
              "priotary": 2,
              "subModuleId": 3,
              "description": "DWH",
              "route": "/catalogs/admin/dwh",
              "actions": []
            },
            {
              "id": 6,
              "status": false,
              "priotary": 3,
              "subModuleId": 3,
              "description": "Bibliotecas digitales",
              "route": "/catalogs/admin/libraries",
              "actions": []
            },
            {
              "id": 7,
              "status": false,
              "priotary": 4,
              "subModuleId": 3,
              "description": "Calendarios",
              "route": "/catalogs/admin/calendars",
              "actions": []
            },
            {
              "id": 8,
              "status": false,
              "priotary": 5,
              "subModuleId": 3,
              "description": "Tipo de Archivos",
              "route": "/catalogs/admin/file-types",
              "actions": []
            },
            {
              "id": 9,
              "status": false,
              "priotary": 6,
              "subModuleId": 3,
              "description": "Parentesco",
              "route": "/catalogs/admin/relationship",
              "actions": []
            },
            {
              "id": 10,
              "status": false,
              "priotary": 7,
              "subModuleId": 3,
              "description": "Parámetros plantillas",
              "route": "/catalogs/admin/template-params",
              "actions": []
            },
            {
              "id": 11,
              "status": false,
              "priotary": 8,
              "subModuleId": 3,
              "description": "Parámetros de servicios",
              "route": "/catalogs/admin/service-params",
              "actions": []
            },
            {
              "id": 12,
              "status": false,
              "priotary": 9,
              "subModuleId": 3,
              "description": "Días de prórroga",
              "route": "/catalogs/admin/days-extension",
              "actions": []
            },
            {
              "id": 13,
              "status": false,
              "priotary": 10,
              "subModuleId": 3,
              "description": "Validacion IA",
              "route": "/catalogs/admin/validation-ia",
              "actions": []
            },
          ]
        },
        {
          "id": 4,
          "status": false,
          "priotary": 2,
          "route": "/catalogs/roles",
          "description": "Roles",
          "moduleId": 2,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 13,
              "status": false,
              "priotary": 1,
              "subModuleId": 4,
              "description": "Portal administración",
              "route": "/catalogs/roles/admin",
              "actions": []
            },
            {
              "id": 14,
              "status": false,
              "priotary": 2,
              "subModuleId": 4,
              "description": "Portal alumnos",
              "route": "/catalogs/roles/student",
              "actions": []
            }
          ]
        },
        {
          "id": 5,
          "status": false,
          "priotary": 3,
          "route": "/catalogs/modules",
          "description": "Módulos y servicios",
          "moduleId": 2,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 15,
              "status": false,
              "priotary": 1,
              "subModuleId": 5,
              "description": "Portal administración",
              "route": "/catalogs/modules/admin",
              "actions": []
            },
            {
              "id": 16,
              "status": false,
              "priotary": 2,
              "subModuleId": 5,
              "description": "Portal alumnos",
              "route": "/catalogs/modules/student/web",
              "actions": []
            },
            {
              "id": 17,
              "status": false,
              "priotary": 3,
              "subModuleId": 5,
              "description": "Aplicación alumnos",
              "route": "/catalogs/modules/student/mobile",
              "actions": []
            },
          ]
        }
      ]
    },
    {
      "id": 3,
      "status": false,
      "priotary": 3,
      "description": "Bibliotecas digitales",
      "subModule": [
        {
          "id": 6,
          "status": false,
          "priotary": 1,
          "route": "/libraries/admin",
          "description": "Administración de bibliotecas",
          "moduleId": 3,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 18,
              "status": false,
              "priotary": 1,
              "subModuleId": 6,
              "description": "Consulta de bibliotecas digitales",
              "route": "/libraries/admin/digital",
              "actions": []
            },
            {
              "id": 19,
              "status": false,
              "priotary": 2,
              "subModuleId": 6,
              "description": "Consulta de documentos administrativos",
              "route": "/libraries/admin/adtve-docs",
              "actions": []
            },
            {
              "id": 20,
              "status": false,
              "priotary": 3,
              "subModuleId": 6,
              "description": "Aprobación de documentos",
              "route": "/libraries/admin/doc-approval",
              "actions": []
            }
          ]
        },
        {
          "id": 7,
          "status": false,
          "priotary": 2,
          "route": "/libraries/params",
          "description": "Administración de parámetros",
          "moduleId": 3,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 21,
              "status": false,
              "priotary": 1,
              "subModuleId": 7,
              "description": "Parámetros",
              "route": "/libraries/params/admin",
              "actions": []
            },
          ]
        }
      ]
    },
    {
      "id": 4,
      "status": false,
      "priotary": 4,
      "description": "Aplicación",
      "subModule": [
        {
          "id": 8,
          "status": false,
          "priotary": 1,
          "route": "/application/personal-information",
          "description": "Datos personales",
          "moduleId": 4,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 22,
              "status": false,
              "priotary": 1,
              "subModuleId": 8,
              "description": "Administración de documentos",
              "route": "/application/personal-information/admin-docs",
              "actions": []
            },
            {
              "id": 23,
              "status": false,
              "priotary": 2,
              "subModuleId": 8,
              "description": "Parámetros",
              "route": "/application/personal-information/params",
              "actions": []
            },
          ]
        },
        {
          "id": 9,
          "status": false,
          "priotary": 2,
          "route": "/application/payments",
          "description": "Pagos",
          "moduleId": 4,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 22,
              "status": false,
              "priotary": 1,
              "subModuleId": 8,
              "description": "Mascara de pagos",
              "route": "/application/payments/mask-payments",
              "actions": []
            }
          ]
        },
      ]
    },
    {
      "id": 5,
      "status": false,
      "priotary": 5,
      "description": "Configuraciones",
      "subModule": [
        {
          "id": 9,
          "status": false,
          "priotary": 1,
          "route": "/settings/images",
          "description": "Administración de imágenes",
          "moduleId": 5,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 24,
              "status": false,
              "priotary": 1,
              "subModuleId": 9,
              "description": "Parametrizar imágenes",
              "route": "/settings/images/parameterize",
              "actions": []
            },
            {
              "id": 25,
              "status": false,
              "priotary": 2,
              "subModuleId": 9,
              "description": "Parámetros",
              "route": "/settings/images/params",
              "actions": []
            },
          ]
        },
        {
          "id": 11,
          "description": "Administrativos",
          "route": "/settings/administratives",
          "status": true,
          "moduleId": 5,
          "hideServices": false,
          "notServices": false,
          "prioritary": 3,
          "services": [
            {
              "id": 1,
              "status": false,
              "priotary": 1,
              "subModuleId": 0,
              "description": "Firmantes",
              "route": "/settings/administratives/signatories",
              "actions": []
            },
            {
              "id": 2,
              "status": false,
              "priotary": 2,
              "subModuleId": 0,
              "description": "Perfiles",
              "route": "/settings/administratives/profiles",
              "actions": []
            },
            {
              "id": 3,
              "status": false,
              "priotary": 3,
              "subModuleId": 0,
              "description": "Puestos",
              "route": "/settings/administratives/positions",
              "actions": []
            },
          ]
        },
        {
          "id": 10,
          "status": false,
          "priotary": 2,
          "route": "/settings/binnacle",
          "description": "Bitacora",
          "moduleId": 5,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 26,
              "status": false,
              "priotary": 1,
              "subModuleId": 10,
              "description": "Consulta de movimientos",
              "route": "/settings/binnacle/movements",
              "actions": []
            },
            {
              "id": 27,
              "status": false,
              "priotary": 2,
              "subModuleId": 10,
              "description": "Parámetros",
              "route": "/settings/binnacle/params",
              "actions": []
            },
            {
              "id": 28,
              "status": false,
              "priotary": 3,
              "subModuleId": 10,
              "description": "Alumnos",
              "route": "/settings/binnacle/students",
              "actions": []
            },
            {
              "id": 28,
              "status": false,
              "priotary": 3,
              "subModuleId": 10,
              "description": "Pagos",
              "route": "/settings/binnacle/payments",
              "actions": []
            }
          ]
        },
        {
          "id": 11,
          "status": false,
          "priotary": 3,
          "route": "/settings/campus",
          "description": "Campus",
          "moduleId": 5,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 29,
              "status": false,
              "priotary": 1,
              "subModuleId": 11,
              "description": "Información de campus",
              "route": "/settings/campus/info",
              "actions": []
            }
          ]
        },
        {
          "id": 11,
          "status": false,
          "priotary": 3,
          "route": "/settings/credential",
          "description": "Credencial digital",
          "moduleId": 5,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 29,
              "status": false,
              "priotary": 1,
              "subModuleId": 11,
              "description": "Configuración",
              "route": "/settings/credential/config",
              "actions": []
            }
          ]
        },
        {
          "id": 13,
          "description": "Documentos",
          "route": "/settings/documents",
          "status": true,
          "moduleId": 5,
          "hideServices": false,
          "notServices": false,
          "prioritary": 6,
          "services": [
            {
              "id": 1,
              "status": false,
              "priotary": 1,
              "subModuleId": 0,
              "description": "Constancias",
              "route": "/settings/documents/certificates",
              "actions": []
            },
            {
              "id": 2,
              "status": false,
              "priotary": 1,
              "subModuleId": 0,
              "description": "Logotipos",
              "route": "/settings/documents/logos",
              "actions": []
            },
            {
              "id": 2,
              "status": false,
              "priotary": 1,
              "subModuleId": 0,
              "description": "Tipo de documento",
              "route": "/settings/documents/type-document",
              "actions": []
            },
          ]
        },
        {
          "id": 13,
          "status": false,
          "priotary": 5,
          "route": "/settings/domains",
          "description": "Dominios",
          "moduleId": 4,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 30,
              "status": false,
              "priotary": 1,
              "subModuleId": 12,
              "description": "Portal administración",
              "route": "/settings/domains/admin",
              "actions": []
            },
            {
              "id": 31,
              "status": false,
              "priotary": 2,
              "subModuleId": 12,
              "description": "Portal alumnos",
              "route": "/settings/domains/student",
              "actions": []
            }
          ]
        },
        {
          "id": 12,
          "status": false,
          "priotary": 5,
          "route": "/settings/tickets",
          "description": "Tickets",
          "moduleId": 4,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 30,
              "status": false,
              "priotary": 1,
              "subModuleId": 12,
              "description": "Parámetros",
              "route": "/settings/tickets/params",
              "actions": []
            }
          ]
        },
        {
          "id": 12,
          "status": false,
          "priotary": 5,
          "route": "/settings/banner",
          "description": "Banner 9",
          "moduleId": 4,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 30,
              "status": false,
              "priotary": 1,
              "subModuleId": 12,
              "description": "Campus",
              "route": "/settings/banner/campus",
              "actions": []
            }
          ]
        },
        {
          "id": 13,
          "status": false,
          "priotary": 5,
          "route": "/settings/payment-methods",
          "description": "Configuración de medios de pago",
          "moduleId": 4,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 30,
              "status": false,
              "priotary": 1,
              "subModuleId": 12,
              "description": "Parámetros",
              "route": "/settings/payment-methods/params",
              "actions": []
            }
          ]
        }
      ]
    },
    {
      "id": 6,
      "status": false,
      "priotary": 6,
      "description": "Expediente digital",
      "subModule": [
        {
          "id": 13,
          "status": false,
          "priotary": 1,
          "route": "/file/admin",
          "description": "Administración de expedientes",
          "moduleId": 6,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 32,
              "status": false,
              "priotary": 1,
              "subModuleId": 13,
              "description": "Administración de documentos",
              "route": "/file/admin/docs",
              "actions": []
            },
            {
              "id": 33,
              "status": false,
              "priotary": 2,
              "subModuleId": 13,
              "description": "Tipo de expedientes",
              "route": "/file/admin/types",
              "actions": []
            }
          ]
        },
        {
          "id": 14,
          "status": false,
          "priotary": 2,
          "route": "/file/assignment",
          "description": "Asignación de expedientes",
          "moduleId": 6,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 34,
              "status": false,
              "priotary": 1,
              "subModuleId": 14,
              "description": "Monitoreo de asignaciones masivas",
              "route": "/file/assignment/monitoring",
              "actions": []
            },
            {
              "id": 44,
              "status": false,
              "priotary": 1,
              "subModuleId": 14,
              "description": "Proceso de asignaciones masivas",
              "route": "/file/assignment/shipping",
              "actions": []
            }
          ]
        },
        {
          "id": 15,
          "status": false,
          "priotary": 3,
          "route": "/file/params",
          "description": "Administración de parámetros",
          "moduleId": 6,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 35,
              "status": false,
              "priotary": 1,
              "subModuleId": 15,
              "description": "Parámetros",
              "route": "/file/params/admin",
              "actions": []
            },
            {
              "id": 36,
              "status": false,
              "priotary": 2,
              "subModuleId": 15,
              "description": "Catálogo de banner",
              "route": "/file/params/banner",
              "actions": []
            },
            {
              "id": 37,
              "status": false,
              "priotary": 3,
              "subModuleId": 15,
              "description": "Archivos de documento de prorrogas",
              "route": "/file/params/file-types",
              "actions": []
            },
            {
              "id": 38,
              "status": false,
              "priotary": 4,
              "subModuleId": 15,
              "description": "Catálogo otros orígenes",
              "route": "/file/params/other-origins",
              "actions": []
            },
          ]
        }
      ]
    },
    {
      "id": 7,
      "status": false,
      "priotary": 7,
      "description": "Calendarios",
      "subModule": [
        {
          "id": 16,
          "status": false,
          "priotary": 1,
          "route": "/calendar/admin",
          "description": "Administración de calendarios",
          "moduleId": 7,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 39,
              "status": false,
              "priotary": 1,
              "subModuleId": 16,
              "description": "Consulta de calendarios",
              "route": "/calendar/admin/consult",
              "actions": []
            }
          ]
        },
        {
          "id": 17,
          "status": false,
          "priotary": 2,
          "route": "/calendar/params",
          "description": "Administración de parámetros",
          "moduleId": 7,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 40,
              "status": false,
              "priotary": 1,
              "subModuleId": 17,
              "description": "Parámetros",
              "route": "/calendar/params/admin",
              "actions": []
            },
          ]
        }
      ]
    },
    {
      "id": 8,
      "status": false,
      "priotary": 8,
      "description": "Notificaciones",
      "subModule": [
        {
          "id": 18,
          "status": false,
          "priotary": 1,
          "route": "/notifications/admin",
          "description": "Administración de notificaciones",
          "moduleId": 8,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 41,
              "status": false,
              "priotary": 1,
              "subModuleId": 18,
              "description": "Notificaciones transaccionales",
              "route": "/notifications/admin/transactional",
              "actions": []
            },
            {
              "id": 42,
              "status": false,
              "priotary": 2,
              "subModuleId": 18,
              "description": "Plantillas Whatsapp",
              "route": "/notifications/admin/whatsapp",
              "actions": []
            },
            {
              "id": 43,
              "status": false,
              "priotary": 2,
              "subModuleId": 18,
              "description": "Origen notificación push",
              "route": "/notifications/admin/origins-push",
              "actions": []
            }
          ]
        },
        {
          "id": 0,
          "status": false,
          "priotary": 2,
          "route": "/notifications/classifications",
          "description": "Administración de tipificaciones",
          "moduleId": 8,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 0,
              "status": false,
              "priotary": 1,
              "subModuleId": 0,
              "description": "Configuraciones",
              "route": "/notifications/classifications/settings",
              "actions": []
            },
          ]
        },
        {
          "id": 0,
          "status": false,
          "priotary": 3,
          "route": "/notifications/surveys-and-notices",
          "description": "Encuestas y avisos",
          "moduleId": 9,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 0,
              "status": false,
              "priotary": 1,
              "subModuleId": 0,
              "description": "Administración de encuestas y avisos",
              "route": "/notifications/surveys-and-notices/admin-surveys",
              "actions": []
            }
          ]
        }
      ]
    },
    {
      "id": 9,
      "status": false,
      "priotary": 9,
      "description": "Plantillas",
      "subModule": [
        {
          "id": 19,
          "status": false,
          "priotary": 1,
          "route": "/templates/admin",
          "description": "Administración de plantillas",
          "moduleId": 9,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 43,
              "status": false,
              "priotary": 1,
              "subModuleId": 19,
              "description": "Cartas de aceptación",
              "route": "/templates/admin/acceptance-letters",
              "actions": []
            }
          ]
        },
        {
          "id": 20,
          "status": false,
          "priotary": 1,
          "route": "/templates/admin-reports",
          "description": "Administración de boletas",
          "moduleId": 9,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 43,
              "status": false,
              "priotary": 1,
              "subModuleId": 19,
              "description": "Boletas",
              "route": "/templates/admin-reports/reports",
              "actions": []
            }
          ]
        }
      ]
    }
  ],
  "user": {
    "id": 1,
    "email": "doe@axity.com",
    "fullName": "User Local DevA",
    "name": "User Local DevA",
    "lastName": "Guzman",
    "azureId": "dsfsdfsd",
    "userResponse": null,
    "campusSelected": [],
    "rolesSelected": [],
    "status": true,
    "searched": false
  },
  "rols": [
    {
      "id": 1,
      "description": "Super administrador",
      "status": true
    }
  ]
}

export const MOCK_MENU_USER_WHITHOUT_SERVICE = {
  "modules": [
    {
      "id": 1,
      "status": false,
      "priotary": 1,
      "description": "Usuarios",
      "subModule": [
        {
          "id": 1,
          "status": false,
          "route": "/users/enrollment",
          "description": "Enrolamiento de usuarios",
          "moduleId": 1,
          "notServices": false,
          "hideServices": false,
          "services": []
        }
      ]
    },
    {
      "id": 2,
      "status": false,
      "priotary": 2,
      "description": "Catálogos",
      "subModule": [
        {
          "id": 2,
          "status": false,
          "route": "/catalogs/campus",
          "description": "Campus",
          "moduleId": 2,
          "notServices": false,
          "hideServices": false,
          "services": []
        },
        {
          "id": 3,
          "status": false,
          "route": "/catalogs/dwh",
          "description": "DWH",
          "moduleId": 2,
          "notServices": false,
          "hideServices": false,
          "services": []
        },
        {
          "id": 3,
          "status": false,
          "route": "/catalogs/libraries",
          "description": "Bibliotecas digitales",
          "moduleId": 2,
          "notServices": false,
          "hideServices": false,
          "services": []
        },
        {
          "id": 4,
          "status": false,
          "route": "/catalogs/roles",
          "description": "Roles",
          "moduleId": 2,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 3,
              "status": false,
              "subModuleId": 2,
              "description": "Portal administración",
              "route": "/catalogs/roles/admin"
            },
            {
              "id": 4,
              "status": false,
              "subModuleId": 2,
              "description": "Portal alumnos",
              "route": "/catalogs/roles/student/web"
            },
            {
              "id": 5,
              "status": false,
              "subModuleId": 2,
              "description": "Aplicación alumnos",
              "route": "/catalogs/roles/student/mobile"
            },
          ]
        },
        {
          "id": 5,
          "status": false,
          "route": "/catalogs/modules",
          "description": "Módulos y servicios",
          "moduleId": 2,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 4,
              "status": false,
              "subModuleId": 2,
              "description": "Portal administración",
              "route": "/catalogs/modules/admin"
            },
            {
              "id": 5,
              "status": false,
              "subModuleId": 2,
              "description": "Portal alumnos",
              "route": "/catalogs/modules/student/web"
            },
            {
              "id": 6,
              "status": false,
              "subModuleId": 2,
              "description": "Aplicación alumnos",
              "route": "/catalogs/modules/student/mobile"
            },
          ]
        }
      ]
    },
    {
      "id": 3,
      "status": false,
      "priotary": 3,
      "description": "Bibliotecas digitales",
      "subModule": [
        {
          "id": 3,
          "status": false,
          "route": "/libraries/digital",
          "description": "Consulta de bibliotecas digitales",
          "moduleId": 3,
          "notServices": false,
          "hideServices": false,
          "services": []
        },
        {
          "id": 4,
          "status": false,
          "route": "/libraries/adtve-docs",
          "description": "Consulta de documentos administrativos",
          "moduleId": 3,
          "notServices": false,
          "hideServices": false,
          "services": []
        },
        {
          "id": 5,
          "status": false,
          "route": "/libraries/doc-approval",
          "description": "Aprobación de documentos",
          "moduleId": 3,
          "notServices": false,
          "hideServices": false,
          "services": []
        }
      ]
    },
    {
      "id": 4,
      "status": false,
      "priotary": 4,
      "description": "Módulos de servicios",
      "subModule": [
        {
          "id": 6,
          "status": false,
          "route": "/services/admin",
          "description": "Administración",
          "moduleId": 4,
          "notServices": false,
          "hideServices": false,
          "services": []
        }
      ]
    },
    {
      "id": 5,
      "status": false,
      "priotary": 5,
      "description": "Comunicaciones",
      "subModule": [
        {
          "id": 7,
          "status": false,
          "route": "/communications/admin",
          "description": "Administración",
          "moduleId": 5,
          "notServices": false,
          "hideServices": false,
          "services": []
        }
      ]
    },
    {
      "id": 6,
      "status": false,
      "priotary": 6,
      "description": "Configuraciones",
      "subModule": [
        {
          "id": 8,
          "status": false,
          "route": "/settings/admin",
          "description": "Administración",
          "moduleId": 6,
          "notServices": false,
          "hideServices": false,
          "services": []
        }
      ]
    },
    {
      "id": 7,
      "status": false,
      "priotary": 7,
      "description": "Expediente digital",
      "subModule": [
        {
          "id": 9,
          "status": false,
          "route": "/file/admin",
          "description": "Administración",
          "moduleId": 7,
          "notServices": false,
          "hideServices": false,
          "services": []
        }
      ]
    }
  ],
  "user": {
    "id": 1,
    "email": "doe@axity.com",
    "fullName": "User Local DevA",
    "name": "User Local DevA",
    "lastName": "Guzman",
    "azureId": "dsfsdfsd",
    "userResponse": null,
    "campusSelected": [],
    "rolesSelected": [],
    "status": true,
    "searched": false
  }
}

export const MOCK_USERS = {
  "countPage": 0,
  "totalRegister": 8,
  "page": 1,
  "size": 10,
  "data": [
    {
      "id": 1,
      "email": "doe@axity.com",
      "fullName": "Jon doe perez",
      "name": "Jon doe",
      "lastName": "perez",
      "azureId": "dsfsdfsd",
      "userResponse": null,
      "campusSelected": [],
      "rolesSelected": [
        "Super Administrador"
      ],
      "status": true,
      "searched": false
    },
    {
      "id": 2,
      "email": "ricardo.jimenez@axity.com",
      "fullName": "Ricardo Jimenez lopez",
      "name": "Ricardo Jimenez",
      "lastName": "lopez",
      "azureId": "sdfsdfsdfsdf2",
      "userResponse": null,
      "campusSelected": [],
      "rolesSelected": [
        "Super Administrador"
      ],
      "status": true,
      "searched": false
    },
    {
      "id": 8,
      "email": "test@test.com",
      "fullName": "test test",
      "name": "test",
      "lastName": "test",
      "azureId": "001",
      "userResponse": null,
      "campusSelected": [
        "SAN RAFAEL",
        "ROMA"
      ],
      "rolesSelected": [
        "Super Administrador",
        "Administrador de finanzas",
        "Adm de bibliotecas",
        "Adm de portal alumnos"
      ],
      "status": true,
      "searched": false
    },
    {
      "id": 9,
      "email": "test@test.com",
      "fullName": "test test",
      "name": "test",
      "lastName": "test",
      "azureId": "001",
      "userResponse": null,
      "campusSelected": [
        "SAN RAFAEL",
        "ROMA"
      ],
      "rolesSelected": [
        "Super Administrador",
        "Administrador de finanzas",
        "Adm de bibliotecas",
        "Adm de portal alumnos"
      ],
      "status": true,
      "searched": false
    },
    {
      "id": 10,
      "email": "test@test.com",
      "fullName": "test test",
      "name": "test",
      "lastName": "test",
      "azureId": "002",
      "userResponse": null,
      "campusSelected": [
        "SAN RAFAEL",
        "ROMA"
      ],
      "rolesSelected": [
        "Super Administrador",
        "Administrador de finanzas",
        "Adm de bibliotecas",
        "Adm de portal alumnos"
      ],
      "status": true,
      "searched": false
    },
    {
      "id": 11,
      "email": "test@test.com",
      "fullName": "test test",
      "name": "test",
      "lastName": "test",
      "azureId": "003",
      "userResponse": null,
      "campusSelected": [
        "SAN RAFAEL",
        "ROMA"
      ],
      "rolesSelected": [
        "Super Administrador",
        "Administrador de finanzas",
        "Adm de bibliotecas",
        "Adm de portal alumnos"
      ],
      "status": true,
      "searched": false
    },
    {
      "id": 12,
      "email": "ricardo.zepeda@laureate.mx",
      "fullName": "Ricardo Zepeda Sepulveda ",
      "name": "Ricardo Zepeda Sepulveda",
      "lastName": null,
      "azureId": "a49aac38-466c-4dce-972f-d9a1e5625851",
      "userResponse": null,
      "campusSelected": [],
      "rolesSelected": [
        "Super Administrador"
      ],
      "status": true,
      "searched": false
    },
    {
      "id": 13,
      "email": "ricardo.reyes@uvmnet.edu",
      "fullName": "Ricardo Reyes Rodriguez ",
      "name": "Ricardo Reyes Rodriguez",
      "lastName": null,
      "azureId": "29540e03-80a1-414e-b31e-3586eb8794f2",
      "userResponse": null,
      "campusSelected": [],
      "rolesSelected": [
        "Super Administrador",
        "Administrador de finanzas",
        "Adm de bibliotecas",
        "Adm de portal alumnos"
      ],
      "status": true,
      "searched": false
    }
  ]
}

export const MOCK_ACTIONS = {
  "Aprobar": false,
  "Crear": false,
  "Editar": false,
  "Ejecutar": false,
  "Eliminar": false,
  "Lectura": false
}

export const MOCK_SERVICES_ACTIONS = {
  "code": 200,
  "message": "Ok",
  "messageError": "",
  "codeError": 0,
  "data": [
    {
      "id": 0,
      "description": "Aprobar",
      "enabled": false,
      "selected": false,
      "status": false,
      "idUserCreated": null,
      "feCreation": "0001-01-01T00:00:00",
      "idUserUpdated": null,
      "feUpdate": null
    },
    {
      "id": 0,
      "description": "Crear",
      "enabled": false,
      "selected": false,
      "status": false,
      "idUserCreated": null,
      "feCreation": "0001-01-01T00:00:00",
      "idUserUpdated": null,
      "feUpdate": null
    },
    {
      "id": 0,
      "description": "Editar",
      "enabled": false,
      "selected": false,
      "status": false,
      "idUserCreated": null,
      "feCreation": "0001-01-01T00:00:00",
      "idUserUpdated": null,
      "feUpdate": null
    },
    {
      "id": 0,
      "description": "Eliminar",
      "enabled": false,
      "selected": false,
      "status": false,
      "idUserCreated": null,
      "feCreation": "0001-01-01T00:00:00",
      "idUserUpdated": null,
      "feUpdate": null
    },
    {
      "id": 0,
      "description": "Lectura",
      "enabled": false,
      "selected": false,
      "status": false,
      "idUserCreated": null,
      "feCreation": "0001-01-01T00:00:00",
      "idUserUpdated": null,
      "feUpdate": null
    },
    {
      "id": 0,
      "description": "Ejecutar",
      "enabled": false,
      "selected": false,
      "status": false,
      "idUserCreated": null,
      "feCreation": "0001-01-01T00:00:00",
      "idUserUpdated": null,
      "feUpdate": null
    }
  ]
}


export const MOCK_PRIORITY_MENU = [
  {
    "priotary": 1,
    "description": "Usuarios",
    "subModule": [
      {
        "priotary": 1,
        "route": "/users/enrollment",
        "description": "Enrolamiento de usuarios",
        "services": [
          {
            "priotary": 1,
            "description": "Portal administración",
            "route": "/users/enrollment/admin"
          },
          {
            "priotary": 2,
            "description": "Portal alumnos",
            "route": "/users/enrollment/student"
          }
        ]
      },
      {
        "priotary": 2,
        "route": "/users/tutors",
        "description": "Tutores",
        "services": [
          {
            "priotary": 1,
            "description": "Administración de tutores",
            "route": "/users/tutors/admin"
          }
        ]
      }
    ]
  },
  {
    "priotary": 2,
    "description": "Catálogos",
    "subModule": [
      {
        "priotary": 1,
        "route": "/catalogs/admin",
        "description": "Administración de catálogos",
        "services": [
          {
            "priotary": 1,
            "description": "Campus",
            "route": "/catalogs/admin/campus"
          },
          {
            "priotary": 2,
            "description": "DWH",
            "route": "/catalogs/admin/dwh"
          },
          {
            "priotary": 3,
            "description": "Bibliotecas digitales",
            "route": "/catalogs/admin/libraries"
          },
          {

            "priotary": 4,
            "description": "Calendarios",
            "route": "/catalogs/admin/calendars"
          },
          {
            "priotary": 5,
            "description": "Tipo de Archivos",
            "route": "/catalogs/admin/file-types"
          },
          {
            "priotary": 6,
            "description": "Parentesco",
            "route": "/catalogs/admin/relationship"
          },
          {
            "priotary": 7,
            "description": "Parámetros plantillas",
            "route": "/catalogs/admin/template-params"
          },
          {
            "priotary": 8,
            "description": "Parámetros de servicios",
            "route": "/catalogs/admin/service-params"
          },
          {
            "priotary": 9,
            "description": "Días de prórroga",
            "route": "/catalogs/admin/days-extension"
          }
        ]
      },
      {
        "priotary": 2,
        "route": "/catalogs/roles",
        "description": "Roles",
        "services": [
          {
            "priotary": 1,
            "description": "Portal administración",
            "route": "/catalogs/roles/admin"
          },
          {
            "priotary": 2,
            "description": "Portal alumnos",
            "route": "/catalogs/roles/student"
          }
        ]
      },
      {
        "priotary": 3,
        "route": "/catalogs/modules",
        "description": "Módulos y servicios",
        "services": [
          {
            "priotary": 1,
            "description": "Portal administración",
            "route": "/catalogs/modules/admin"
          },
          {
            "priotary": 2,
            "description": "Portal alumnos",
            "route": "/catalogs/modules/student/web"
          },
          {
            "priotary": 3,
            "description": "Aplicación alumnos",
            "route": "/catalogs/modules/student/mobile"
          }
        ]
      }
    ]
  },
  {
    "priotary": 3,
    "description": "Bibliotecas digitales",
    "subModule": [
      {
        "priotary": 1,
        "route": "/libraries/admin",
        "description": "Administración de bibliotecas",
        "services": [
          {
            "priotary": 1,
            "description": "Consulta de bibliotecas digitales",
            "route": "/libraries/admin/digital"
          },
          {
            "priotary": 2,
            "description": "Consulta de documentos administrativos",
            "route": "/libraries/admin/adtve-docs"
          },
          {
            "priotary": 3,
            "description": "Aprobación de documentos",
            "route": "/libraries/admin/doc-approval"
          }
        ]
      },
      {
        "priotary": 2,
        "route": "/libraries/params",
        "description": "Administración de parámetros",
        "services": [
          {
            "priotary": 1,
            "description": "Parámetros",
            "route": "/libraries/params/admin"
          }
        ]
      }
    ]
  },
  {
    "priotary": 4,
    "description": "Configuraciones",
    "subModule": [
      {
        "priotary": 1,
        "route": "/settings/images",
        "description": "Administración de imágenes",
        "services": [
          {
            "priotary": 1,
            "description": "Parametrizar imágenes",
            "route": "/settings/images/parameterize"
          },
          {
            "priotary": 2,
            "description": "Parámetros",
            "route": "/settings/images/params"
          }
        ]
      },
      {

        "priotary": 2,
        "route": "/settings/binnacle",
        "description": "Bitacora",
        "services": [
          {
            "priotary": 1,
            "description": "Consulta de movimientos",
            "route": "/settings/binnacle/movements"
          },
          {
            "priotary": 2,
            "description": "Parámetros",
            "route": "/settings/binnacle/params"
          },
          {
            "priotary": 3,
            "description": "Alumnos",
            "route": "/settings/binnacle/students"
          }
        ]
      },
      {
        "priotary": 3,
        "route": "/settings/credential",
        "description": "Credencial digital",
        "services": [
          {
            "priotary": 1,
            "description": "Configuración",
            "route": "/settings/credential/config"
          }
        ]
      },
      {
        "priotary": 4,
        "route": "/settings/domains",
        "description": "Dominios",
        "services": [
          {
            "priotary": 1,
            "description": "Portal administración",
            "route": "/settings/domains/admin"
          },
          {
            "priotary": 2,
            "description": "Portal alumnos",
            "route": "/settings/domains/student"
          }
        ]
      }
    ]
  },
  {
    "priotary": 5,
    "description": "Expediente digital",
    "subModule": [
      {
        "priotary": 1,
        "route": "/file/admin",
        "description": "Administración de expedientes",
        "services": [
          {
            "priotary": 1,
            "description": "Administración de documentos",
            "route": "/file/admin/docs"
          },
          {
            "priotary": 2,
            "description": "Tipo de expedientes",
            "route": "/file/admin/types"
          }
        ]
      },
      {
        "priotary": 2,
        "route": "/file/assignment",
        "description": "Asignación de expedientes",
        "services": [
          {
            "priotary": 1,
            "description": "Monitoreo de asignaciones masivas",
            "route": "/file/assignment/shipping"
          }
        ]
      },
      {
        "priotary": 3,
        "route": "/file/params",
        "description": "Administración de parámetros",
        "services": [
          {
            "priotary": 1,
            "description": "Parámetros",
            "route": "/file/params/admin"
          },
          {
            "priotary": 2,
            "description": "Catálogo de banner",
            "route": "/file/params/banner"
          },
          {
            "priotary": 3,
            "description": "Archivos de documento de prorrogas",
            "route": "/file/params/file-types"
          }
        ]
      }
    ]
  },
  {
    "priotary": 6,
    "description": "Calendarios",
    "subModule": [
      {
        "priotary": 1,
        "route": "/calendar/admin",
        "description": "Administración de calendarios",
        "services": [
          {
            "priotary": 1,
            "description": "Consulta de calendarios",
            "route": "/calendar/admin/consult"
          }
        ]
      },
      {

        "priotary": 2,
        "route": "/calendar/params",
        "description": "Administración de parámetros",
        "services": [
          {
            "priotary": 1,
            "description": "Parámetros",
            "route": "/calendar/params/admin"
          }
        ]
      }
    ]
  },
  {
    "priotary": 7,
    "description": "Notificaciones",
    "subModule": [
      {
        "priotary": 1,
        "route": "/notifications/admin",
        "description": "Administración de notificaciones",
        "services": [
          {
            "priotary": 1,
            "description": "Notificaciones transaccionales",
            "route": "/notifications/admin/transactional"
          },
          {
            "priotary": 2,
            "description": "Plantillas Whatsapp",
            "route": "/notifications/admin/whatsapp"
          }
        ]
      }
    ]
  },
  {
    "priotary": 8,
    "description": "Plantillas",
    "subModule": [
      {
        "priotary": 1,
        "route": "/templates/admin",
        "description": "Administración de plantillas",
        "services": [
          {
            "priotary": 1,
            "description": "Cartas de aceptación",
            "route": "/templates/admin/acceptance-letters"
          }
        ]
      }
    ]
  }
]


export const MOCK_MENU_USER_NOVALID = {
  "modules": [
    {
      "id": 1,
      "status": false,
      "priotary": 1,
      "description": "Usuarios",
      "subModule": [
        {
          "id": 1,
          "status": false,
          "priotary": 1,
          "route": "",
          "description": "Enrolamiento de usuarios",
          "moduleId": 1,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 1,
              "status": false,
              "priotary": 1,
              "subModuleId": 1,
              "description": "Portal administración",
              "route": "/users/enrollment/admin",
              "actions": []
            },
            {
              "id": 2,
              "status": false,
              "priotary": 2,
              "subModuleId": 1,
              "description": "Portal alumnos",
              "route": "/users/enrollment/student",
              "actions": []
            }
          ]
        },
        {
          "id": 2,
          "status": false,
          "priotary": 2,
          "route": "/users/tutors",
          "description": "Tutores",
          "moduleId": 1,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 3,
              "status": false,
              "priotary": 1,
              "subModuleId": 2,
              "description": "Administración de tutores",
              "route": "/users/tutors/admin",
              "actions": []
            }
          ]
        }
      ]
    },
    {
      "id": 2,
      "status": false,
      "priotary": 2,
      "description": "Catálogos",
      "subModule": [
        {
          "id": 3,
          "status": false,
          "priotary": 1,
          "route": "/catalogs/admin",
          "description": "Administración de catálogos",
          "moduleId": 2,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 4,
              "status": false,
              "priotary": 1,
              "subModuleId": 3,
              "description": "Campus",
              "route": "/catalogs/admin/campus",
              "actions": []
            },
            {
              "id": 5,
              "status": false,
              "priotary": 2,
              "subModuleId": 3,
              "description": "DWH",
              "route": "/catalogs/admin/dwh",
              "actions": []
            },
            {
              "id": 6,
              "status": false,
              "priotary": 3,
              "subModuleId": 3,
              "description": "Bibliotecas digitales",
              "route": "/catalogs/admin/libraries",
              "actions": []
            },
            {
              "id": 7,
              "status": false,
              "priotary": 4,
              "subModuleId": 3,
              "description": "Calendarios",
              "route": "/catalogs/admin/calendars",
              "actions": []
            },
            {
              "id": 8,
              "status": false,
              "priotary": 5,
              "subModuleId": 3,
              "description": "Tipo de Archivos",
              "route": "/catalogs/admin/file-types",
              "actions": []
            },
            {
              "id": 9,
              "status": false,
              "priotary": 6,
              "subModuleId": 3,
              "description": "Parentesco",
              "route": "/catalogs/admin/relationship",
              "actions": []
            },
            {
              "id": 10,
              "status": false,
              "priotary": 7,
              "subModuleId": 3,
              "description": "Parámetros plantillas",
              "route": "/catalogs/admin/template-params",
              "actions": []
            },
            {
              "id": 11,
              "status": false,
              "priotary": 8,
              "subModuleId": 3,
              "description": "Parámetros de servicios",
              "route": "/catalogs/admin/service-params",
              "actions": []
            },
            {
              "id": 12,
              "status": false,
              "priotary": 9,
              "subModuleId": 3,
              "description": "Días de prórroga",
              "route": "/catalogs/admin/days-extension",
              "actions": []
            }
          ]
        },
        {
          "id": 4,
          "status": false,
          "priotary": 2,
          "route": "/catalogs/roles",
          "description": "Roles",
          "moduleId": 2,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 13,
              "status": false,
              "priotary": 1,
              "subModuleId": 4,
              "description": "Portal administración",
              "route": "/catalogs/roles/admin",
              "actions": []
            },
            {
              "id": 14,
              "status": false,
              "priotary": 2,
              "subModuleId": 4,
              "description": "Portal alumnos",
              "route": "/catalogs/roles/student",
              "actions": []
            }
          ]
        },
        {
          "id": 5,
          "status": false,
          "priotary": 3,
          "route": "/catalogs/modules",
          "description": "Módulos y servicios",
          "moduleId": 2,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 15,
              "status": false,
              "priotary": 1,
              "subModuleId": 5,
              "description": "Portal administración",
              "route": "/catalogs/modules/admin",
              "actions": []
            },
            {
              "id": 16,
              "status": false,
              "priotary": 2,
              "subModuleId": 5,
              "description": "Portal alumnos",
              "route": "/catalogs/modules/student/web",
              "actions": []
            },
            {
              "id": 17,
              "status": false,
              "priotary": 3,
              "subModuleId": 5,
              "description": "Aplicación alumnos",
              "route": "/catalogs/modules/student/mobile",
              "actions": []
            },
          ]
        }
      ]
    },
    {
      "id": 3,
      "status": false,
      "priotary": 3,
      "description": "Bibliotecas digitales",
      "subModule": [
        {
          "id": 6,
          "status": false,
          "priotary": 1,
          "route": "/libraries/admin",
          "description": "Administración de bibliotecas",
          "moduleId": 3,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 18,
              "status": false,
              "priotary": 1,
              "subModuleId": 6,
              "description": "Consulta de bibliotecas digitales",
              "route": "/libraries/admin/digital",
              "actions": []
            },
            {
              "id": 19,
              "status": false,
              "priotary": 2,
              "subModuleId": 6,
              "description": "Consulta de documentos administrativos",
              "route": "/libraries/admin/adtve-docs",
              "actions": []
            },
            {
              "id": 20,
              "status": false,
              "priotary": 3,
              "subModuleId": 6,
              "description": "Aprobación de documentos",
              "route": "/libraries/admin/doc-approval",
              "actions": []
            }
          ]
        },
        {
          "id": 7,
          "status": false,
          "priotary": 2,
          "route": "/libraries/params",
          "description": "Administración de parámetros",
          "moduleId": 3,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 21,
              "status": false,
              "priotary": 1,
              "subModuleId": 7,
              "description": "Parámetros",
              "route": "/libraries/params/admin",
              "actions": []
            },
          ]
        }
      ]
    },
    {
      "id": 4,
      "status": false,
      "priotary": 4,
      "description": "Aplicación",
      "subModule": [
        {
          "id": 8,
          "status": false,
          "priotary": 1,
          "route": "/application/personal-information",
          "description": "Datos personales",
          "moduleId": 4,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 22,
              "status": false,
              "priotary": 1,
              "subModuleId": 8,
              "description": "Administración de documentos",
              "route": "/application/personal-information/admin-docs",
              "actions": []
            },
            {
              "id": 23,
              "status": false,
              "priotary": 2,
              "subModuleId": 8,
              "description": "Parámetros",
              "route": "/application/personal-information/params",
              "actions": []
            },
          ]
        }
      ]
    },
    {
      "id": 5,
      "status": false,
      "priotary": 5,
      "description": "Configuraciones",
      "subModule": [
        {
          "id": 9,
          "status": false,
          "priotary": 1,
          "route": "/settings/images",
          "description": "Administración de imágenes",
          "moduleId": 5,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 24,
              "status": false,
              "priotary": 1,
              "subModuleId": 9,
              "description": "Parametrizar imágenes",
              "route": "/settings/images/parameterize",
              "actions": []
            },
            {
              "id": 25,
              "status": false,
              "priotary": 2,
              "subModuleId": 9,
              "description": "Parámetros",
              "route": "/settings/images/params",
              "actions": []
            },
          ]
        },
        {
          "id": 10,
          "status": false,
          "priotary": 2,
          "route": "/settings/binnacle",
          "description": "Bitacora",
          "moduleId": 5,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 26,
              "status": false,
              "priotary": 1,
              "subModuleId": 10,
              "description": "Consulta de movimientos",
              "route": "/settings/binnacle/movements",
              "actions": []
            },
            {
              "id": 27,
              "status": false,
              "priotary": 2,
              "subModuleId": 10,
              "description": "Parámetros",
              "route": "/settings/binnacle/params",
              "actions": []
            },
            {
              "id": 28,
              "status": false,
              "priotary": 3,
              "subModuleId": 10,
              "description": "Alumnos",
              "route": "/settings/binnacle/students",
              "actions": []
            }
          ]
        },
        {
          "id": 11,
          "status": false,
          "priotary": 3,
          "route": "/settings/credential",
          "description": "Credencial digital",
          "moduleId": 5,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 29,
              "status": false,
              "priotary": 1,
              "subModuleId": 11,
              "description": "Configuración",
              "route": "/settings/credential/config",
              "actions": []
            }
          ]
        },
        {
          "id": 12,
          "status": false,
          "priotary": 5,
          "route": "/settings/domains",
          "description": "Dominios",
          "moduleId": 4,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 30,
              "status": false,
              "priotary": 1,
              "subModuleId": 12,
              "description": "Portal administración",
              "route": "/settings/domains/admin",
              "actions": []
            },
            {
              "id": 31,
              "status": false,
              "priotary": 2,
              "subModuleId": 12,
              "description": "Portal alumnos",
              "route": "/settings/domains/student",
              "actions": []
            }
          ]
        }
      ]
    },
    {
      "id": 6,
      "status": false,
      "priotary": 6,
      "description": "Expediente digital",
      "subModule": [
        {
          "id": 13,
          "status": false,
          "priotary": 1,
          "route": "/file/admin",
          "description": "Administración de expedientes",
          "moduleId": 6,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 32,
              "status": false,
              "priotary": 1,
              "subModuleId": 13,
              "description": "Administración de documentos",
              "route": "/file/admin/docs",
              "actions": []
            },
            {
              "id": 33,
              "status": false,
              "priotary": 2,
              "subModuleId": 13,
              "description": "Tipo de expedientes",
              "route": "/file/admin/types",
              "actions": []
            }
          ]
        },
        {
          "id": 14,
          "status": false,
          "priotary": 2,
          "route": "/file/assignment",
          "description": "Asignación de expedientes",
          "moduleId": 6,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 34,
              "status": false,
              "priotary": 1,
              "subModuleId": 14,
              "description": "Monitoreo de asignaciones masivas",
              "route": "/file/assignment/monitoring",
              "actions": []
            }
          ]
        },
        {
          "id": 15,
          "status": false,
          "priotary": 3,
          "route": "/file/params",
          "description": "Administración de parámetros",
          "moduleId": 6,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 35,
              "status": false,
              "priotary": 1,
              "subModuleId": 15,
              "description": "Parámetros",
              "route": "/file/params/admin",
              "actions": []
            },
            {
              "id": 36,
              "status": false,
              "priotary": 2,
              "subModuleId": 15,
              "description": "Catálogo de banner",
              "route": "/file/params/banner",
              "actions": []
            },
            {
              "id": 37,
              "status": false,
              "priotary": 3,
              "subModuleId": 15,
              "description": "Archivos de documento de prorrogas",
              "route": "/file/params/file-types",
              "actions": []
            },
            {
              "id": 38,
              "status": false,
              "priotary": 4,
              "subModuleId": 15,
              "description": "Catálogo otros orígenes",
              "route": "/file/params/other-origins",
              "actions": []
            },
          ]
        }
      ]
    },
    {
      "id": 7,
      "status": false,
      "priotary": 7,
      "description": "Calendarios",
      "subModule": [
        {
          "id": 16,
          "status": false,
          "priotary": 1,
          "route": "/calendar/admin",
          "description": "Administración de calendarios",
          "moduleId": 7,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 39,
              "status": false,
              "priotary": 1,
              "subModuleId": 16,
              "description": "Consulta de calendarios",
              "route": "/calendar/admin/consult",
              "actions": []
            }
          ]
        },
        {
          "id": 17,
          "status": false,
          "priotary": 2,
          "route": "/calendar/params",
          "description": "Administración de parámetros",
          "moduleId": 7,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 40,
              "status": false,
              "priotary": 1,
              "subModuleId": 17,
              "description": "Parámetros",
              "route": "/calendar/params/admin",
              "actions": []
            },
          ]
        }
      ]
    },
    {
      "id": 8,
      "status": false,
      "priotary": 8,
      "description": "Notificaciones",
      "subModule": [
        {
          "id": 18,
          "status": false,
          "priotary": 1,
          "route": "/notifications/admin",
          "description": "Administración de notificaciones",
          "moduleId": 8,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 41,
              "status": false,
              "priotary": 1,
              "subModuleId": 18,
              "description": "Notificaciones transaccionales",
              "route": "/notifications/admin/transactional",
              "actions": []
            },
            {
              "id": 42,
              "status": false,
              "priotary": 2,
              "subModuleId": 18,
              "description": "Plantillas Whatsapp",
              "route": "/notifications/admin/whatsapp",
              "actions": []
            }
          ]
        },
        {
          "id": 0,
          "status": false,
          "priotary": 2,
          "route": "/notifications/classifications",
          "description": "Administración de tipificaciones",
          "moduleId": 8,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 0,
              "status": false,
              "priotary": 1,
              "subModuleId": 0,
              "description": "Configuraciones",
              "route": "/notifications/classifications/settings",
              "actions": []
            },
          ]
        }
      ]
    },
    {
      "id": 9,
      "status": false,
      "priotary": 9,
      "description": "Plantillas",
      "subModule": [
        {
          "id": 19,
          "status": false,
          "priotary": 1,
          "route": "/templates/admin",
          "description": "Administración de plantillas",
          "moduleId": 9,
          "notServices": false,
          "hideServices": false,
          "services": [
            {
              "id": 43,
              "status": false,
              "priotary": 1,
              "subModuleId": 19,
              "description": "Cartas de aceptación",
              "route": "/templates/admin/acceptance-letters",
              "actions": []
            }
          ]
        }
      ]
    }
  ],
  "user": {
    "id": 1,
    "email": "doe@axity.com",
    "fullName": "User Local DevA",
    "name": "User Local DevA",
    "lastName": "Guzman",
    "azureId": "dsfsdfsd",
    "userResponse": null,
    "campusSelected": [],
    "rolesSelected": [],
    "status": true,
    "searched": false
  },
  "rols": [
    {
      "id": 1,
      "description": "Super administrador",
      "status": true
    }
  ]
}
